import * as React from 'react';
import { Component, inject, deps, observer } from '../lib/component';
import {PageGenericPrismic} from '../components/page-generic-prismic';

export interface MusicSubmissionsPageProps {}

@inject(deps) @observer
export class MusicSubmissionsPage extends Component<MusicSubmissionsPageProps> {
  render() {
    return (
      <PageGenericPrismic model={this.props.model.page.musicSubmissions} />
    )
  }
}